export default function CircularSpinner({ className }) {
    return (
        <div className={className}>
            <div className="w-10 h-10 rounded-full border-8 border-green-400 border-t-white animate-spin">
            </div>
        </div>
    )
}